export const GRC = {
    MARKETING: {
        GetExtractionTypes: 'Services/CRM/ClientExtractionService.svc/GetExtractionTypes',
        GetExtractions: 'Services/CRM/ClientExtractionService.svc/GetExtractions',
        GetExtractionById: 'Services/CRM/ClientExtractionService.svc/GetExtractionById',
        CancelExtraction: 'Services/CRM/ClientExtractionService.svc/CancelExtraction',
        ReactivateExtraction: 'Services/CRM/ClientExtractionService.svc/ReactivateExtraction',
        CreateExtractionItem: 'Services/CRM/ClientExtractionService.svc/CreateExtractionItem',
        UpdateExtractionItem: 'Services/CRM/ClientExtractionService.svc/UpdateExtractionItem',
        GetAllExportableFields: 'Services/CRM/ClientExtractionService.svc/GetAllExportableFields',
        GetExtractionDuplicates: 'Services/CRM/ClientExtractionService.svc/GetExtractionDuplicates',
        CloseExtraction: 'Services/CRM/ClientExtractionService.svc/CloseExtraction',
        ExportMarketingCSVFile: 'Services/CRM/ClientExtractionService.svc/ExportMarketingCSVFile',
        GetExtractionCustomers: 'Services/CRM/ClientExtractionService.svc/GetExtractionCustomers',
        GetExtractionCustomerCodes: 'Services/CRM/ClientExtractionService.svc/GetExtractionCustomerCodes',
        GetFilterCategories: 'Services/CRM/ClientExtractionService.svc/GetFilterCategories',
        GetExclusionConfiguration: 'Services/CRM/ClientExtractionService.svc/GetExclusionConfiguration',
        GetExtractionExclusionById:'Services/CRM/ClientExtractionService.svc/GetExtractionExclusionById',
        UpdateExtractionExclusion:'Services/CRM/ClientExtractionService.svc/UpdateExtractionExclusion',
        DeleteConfigExtractionFilter:'Services/CRM/ClientExtractionService.svc/DeleteConfigExtractionFilter',
        UpdateConfigExtractionFilter:'Services/CRM/ClientExtractionService.svc/UpdateConfigExtractionFilter',
        AddConfigExtractionFilter:'Services/CRM/ClientExtractionService.svc/AddConfigExtractionFilter',
    }
}


